export default "__VITE_ASSET__bb093ec8__"